var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',[_c('strong',[_vm._v("Gemini Sistemas")]),_vm._v(" © "+_vm._s(_vm.ano)+" - build #1482 - Versão #8\n  ")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab618caa","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./FrontEnd/componentes/Footer.vue
// module id = 2234
// module chunks = 0